import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectSelectedTask, clearSelectedTask } from '../../slice/taskSlice'
import Arrow from './assets/x.svg'

import Overview from './assets/overview.svg'
import SQ from './assets/sq.svg'
import Sp from './assets/sp.svg'

import OverViewComp from './components/Overview'
import StandarQustions from './components/StandarQustions'
import SystemPrompts from './components/SystemPrompts'

const tabList = [
  {
    id: 1,
    title: "Übersicht",
    icon: Overview,
    component: <OverViewComp />
  },
  {
    id: 2, 
    title: "Standardfragen",
    icon: SQ,
    component: <StandarQustions />
  },
  {
    id: 3,
    title: " KI-Profil",
    icon: Sp,
    component: <SystemPrompts />
  }
]
const AddTasks = ({ setShowAddTask }) => {
  const [selectedTab, setSelectedTab] = useState(1)
  const dispatch = useDispatch();
  
  // Get the selected task from Redux store
  const selectedTask = useSelector(selectSelectedTask);

  useEffect(() => {
    // Optional: You can perform actions when a task is selected
    if (selectedTask) {
      console.log('Selected Task:', selectedTask);
      // You might want to pre-fill some form fields or perform other actions
    }
  }, [selectedTask]);

  const handleClose = () => {
    // Clear selected task when closing
    dispatch(clearSelectedTask());
    setShowAddTask(false);
  };

  return (
    <div className=''>
      <div className='border-b border-gray-200 pb-5'>
        <div className='flex justify-between items-start gap-5 pr-10 pl-10 pt-10'>
          <div className='flex flex-col gap-1'>
            <h1 className='text-2xl font-bold'>
              {selectedTask ? `Bearbeiten Sie Ihre Aufgabe: ${selectedTask.name}` : 'Add To Task'}
            </h1>
            <p className='text-sm text-gray-500'>
              {selectedTask 
                ? `Bearbeiten Sie die Aufgabendetails, 
stellen Sie Fragen und verwalten Sie das 
KI-Profil.` 
                : 'Bearbeiten Sie die Aufgabendetails, stellen Sie Fragen und verwalten Sie das KI-Profil.'}
            </p>
          </div>
          <img src={Arrow} alt="arrow" className='cursor-pointer' onClick={handleClose} />
        </div>
      </div>
      <div className='max-w-7xl mx-auto'>
        <div className='flex pt-10 pr-10 pl-10 '>
          {tabList.map((tab) => (
            <div 
              key={tab.id} 
              className={`flex items-center gap-3 p-3 cursor-pointer hover:bg-gray-50  ${selectedTab === tab.id ? 'bg-white border-b-4 border-custom-yellow' : ''}`}
              onClick={() => setSelectedTab(tab.id)}
            >
              <span className="text-gray-700">{tab.title}</span>
            </div>
          ))}
        </div>

        <div className="mt-6 pr-10 pl-10">
          {tabList.find(tab => tab.id === selectedTab)?.component}
        </div>
      </div>
    </div>
  )
}

export default AddTasks